"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = void 0;
var regex = new RegExp(/^(\S+[^/])\/(\S+?) \(Kiwi\.com (\S+?)\)(?: ?(?:.*))$/);
var parse = function (useragent) {
    var parsedUA = regex.exec(useragent);
    if (!parsedUA) {
        return new Error("Regex failed to compile");
    }
    return {
        name: parsedUA[1],
        version: parsedUA[2],
        environment: parsedUA[3],
        systemInfo: parsedUA[4] || "",
    };
};
exports.parse = parse;
//# sourceMappingURL=parse.js.map